import { render, staticRenderFns } from "./aktiveLogsDoneBtn.vue?vue&type=template&id=6876234e&scoped=true&"
import script from "./aktiveLogsDoneBtn.vue?vue&type=script&lang=js&"
export * from "./aktiveLogsDoneBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876234e",
  null
  
)

export default component.exports